import type { CSSProperties } from 'react';
import styled from 'styled-components';

import { useCommonGameSet } from '#src/set/index.ts';

const StyledImg = styled.img`
  object-fit: contain;
`;

type Props = {
  className?: string;
  style?: CSSProperties;
};
export const SetLogo = ({ className, style }: Props) => {
  const commonGameSet = useCommonGameSet();

  return (
    <StyledImg
      src={commonGameSet.visual.brand.logoImage}
      alt={commonGameSet.name || ''}
      className={className}
      style={style}
    />
  );
};
